import { seedValue } from "faker";
import React from "react";
import { useNavigate } from "react-router";
import RequestCard from "./RequestCard";
const RequestsList = ({ data }) => {
  const navigate = useNavigate();
  const handlePage = (request_type, request_slug) => {
    if (request_type === "pending") {
      navigate(`/pending-request/${request_slug}`);
    } else {
      navigate(`/active-request/${request_slug}`);
    }
  };

  return (
    <div className="col-lg-12">
      {data.map((bill, index) => {
        return (
          <RequestCard
            bill={bill}
            handlePage={handlePage}
            btn_title="View detail"
          />
        );
      })}
    </div>
  );
};

export default RequestsList;
